import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, TextField } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledDownloadWrapper = styled.div`
  margin-right: 1.5rem;
`;

export const HeadBar = styled.div`
  display: flex;
  align-items: baseline;
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

export const StyledFilters = styled.div`
  display: grid;
  grid-template-columns: 40% 1fr;
  column-gap: 0.5rem;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: 0.5rem;
    text-align: left;
  }
`;

export const StyledHeading = styled.span`
  margin: 0;
  font-size: 2.3rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledIcon = styled.div`
  margin-right: 1rem;
  margin-top: 2rem;
  display: inline-block;
  vertical-align: middle;
`;

export const StyledButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.background.main};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledDownloadIcon = styled(FontAwesomeIcon)`
  && {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

export const StyledNoRecordMessage = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.light};
`;

export const StyledSelect = styled.div`
  display: inline-block;
  vertical-align: middle;
  max-width: 8rem;
  width: 100%;
  text-align: left;
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  margin: 2.4rem 1rem 1rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: center;
    margin: 0;
  }
`;

export const StyledText = styled.div`
  display: grid;
  justify-content: flex-start;
  margin-bottom: 6rem;
  width: 100%;
  text-align: left;
  color: ${({ theme }) => theme.colors.paragraph};

  span {
    color: ${({ theme }) => theme.colors.info.main};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    justify-content: center;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-bottom: 2rem;
  }
`;

export const StyledPagination = styled.div`
  display: grid;
  justify-content: flex-end;
  margin-bottom: 2rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    grid-row: 2;
  }

  @media (max-width: 1320px) {
    justify-content: center;
  }
`;

export const StyledSearch = styled.div`
  flex: 1;
  text-align: left;
  display: flex;
`;

export const StyledDropDown = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 1rem;
    justify-content: flex-end;
  }
`;

export const StyledSize = styled.span`
  margin-right: 0.8rem;
  margin-left: 0.8rem;
  font-size: large;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledHeadingIcon = styled(FontAwesomeIcon)`
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.info.main};
`;

export const StyledTextField = styled(TextField)`
  width: 44.5rem;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 63rem;
  }

  @media (max-width: 42.5rem) {
    width: 33.5rem;
  }
`;
